module.exports = __webpack_public_path__ + "img/gift4-01-c02-y2.d26a1ed8.png";